export default function NoItems() {
    return (
        <div className="opAnim wfc m0a brand">No items matching these criteria</div>
    )
}
